export default "__VITE_ASSET__DlTvIJ30__"